import React from 'react';

import { useIntl } from 'react-intl';

import { IconButton, type IconButtonProps } from '@atlaskit/button/new';
import FullscreenEnterIcon from '@atlaskit/icon/core/fullscreen-enter';

import messages from './messages';

type FullScreenButtonProps = Pick<IconButtonProps, 'onClick'>;

export const FullScreenButton = ({ onClick }: FullScreenButtonProps): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<IconButton
			testId="rovo-chat-full-screen-button"
			isTooltipDisabled={false}
			icon={FullscreenEnterIcon}
			appearance="subtle"
			onClick={onClick}
			label={formatMessage(messages.maximizeChatButtonLabel)}
		/>
	);
};
